import React from "react";
import { Link } from "react-router-dom"; // 👈 import Link
import { products } from "../../products";
import { Card, CardContent } from "./cards";
import { motion } from "framer-motion";

const ProductsPage = () => {
  return (
    <div className="min-h-screen bg-primary dark:bg-primary-dark transition-colors duration-300 text-black dark:text-white px-4 py-8">
      <h1 className="text-4xl font-bold text-center mb-10">Signature Drops</h1>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {products.map((product, index) => (
          <motion.div
            key={product.id}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            {/* 👇 Wrap the entire card with Link */}
            <Link
              to={`/product/${product.id}`}
              className="block hover:no-underline group"
            >
              <Card className="rounded-2xl shadow-lg overflow-hidden border border-white/10 dark:border-white/20 transition-transform duration-300 group-hover:-translate-y-1 group-hover:shadow-xl">
                
                {/* Product Image */}
                <div className="relative w-full h-64 sm:h-80 overflow-hidden">
                  <img
                    src={product.images[product.colors[0]][0]}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                {/* Product Content */}
                <CardContent className="p-4">
                  <h2 className="text-xl font-semibold mb-2 group-hover:text-accent transition-colors">
                    {product.name}
                  </h2>
                  <p className="text-sm mb-4 opacity-80 line-clamp-3">
                    {product.description}
                  </p>
                  <div className="flex items-center justify-between text-lg font-medium">
                    <span>₹{product.price}</span>
                    <span className="text-accent opacity-0 group-hover:opacity-100 transition-opacity">
                      View →
                    </span>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;
